import React from "react";
import Container from "../../../../components/Container";
import Content from "../../../../components/Content";
import Body from "../../components/Body";
import PopupContent from "../../../../components/Popup/PopupContent";
import Popup from "../../../../components/Popup/Popup";

import styles from "./Desktop.module.css";


const Desktop = (props) => {

    const {onClose,popup} = props
    const getPopupContent = () => {
        if (!popup) return;

        return <PopupContent {...popup} />;
    
    }
    const getPopupStyle = () => {
        let popupStyle = { width: "31.25vw" };
        if (popup && popup.type === "spinner") {
          popupStyle = { width: "60%",};
        } else if ( popup &&  (popup.type === "popup")
        ) {
          popupStyle = { width: "30%" };
        }
        return popupStyle;
    }
    return (
        <Container style={styles.container}>
            <Popup visible={!!popup} popupStyle={getPopupStyle()} closePopup={onClose}>
                {getPopupContent()}
            </Popup>
            <Body {...props} />
        </Container>
    )
}

export default Desktop;
